import type {
  ClientPollVoteRequest,
  PagedModelClientPost
} from '@DigitaleDoerfer/digitale-doerfer-api';
import type { InfiniteData } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevinePollEventsApi } from '@/features/api/hooks/grapevine-poll-events/useGrapevinePollEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const usePollVote = () => {
  const queryClient = useQueryClient();
  const api = useGrapevinePollEventsApi();

  return useApiMutation({
    mutationFn: (clientPollVoteRequest: ClientPollVoteRequest) =>
      api.onPollVoteRequest({ clientPollVoteRequest }),
    successMessageKey: 'votePoll.success',
    onSuccess: ({ poll }, { postId }) => {
      queryClient.setQueriesData(
        { queryKey: [API_CACHE_KEYS.POST_FEED] },
        (feed: InfiniteData<PagedModelClientPost, number>) => {
          if (!feed) return feed;
          return {
            ...feed,
            pages: feed.pages.map((feedPage: PagedModelClientPost) => ({
              ...feedPage,
              content: feedPage.content?.map((p) =>
                p.id === postId ? { ...p, poll } : p
              )
            }))
          };
        }
      );
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST, { postId }]
      });
    }
  });
};
